import { Storage } from '@ionic/storage';
import { DataService } from 'src/app/data.service';
import { Component, OnInit } from '@angular/core';

import { Router,NavigationExtras } from '@angular/router';
import { LoaderService } from '../loder_service/loader.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})
export class ProductsComponent implements OnInit {

  category:any 
  cart_count:any=0;
  constructor(public storage:Storage,public restApi:DataService, public toastService:LoaderService, private router: Router, private data:DataService) { }

  ngOnInit() {
    
  }

  
  ionViewWillEnter(){
    
      if(localStorage.getItem('cart_count')){
        this.cart_count=localStorage.getItem('cart_count')
      }else{
        this.cart_count='';
      }
 
    this.toastService.showLoader('')
   this.restApi.get_category().subscribe((data:any)=>{
      this.category=data.cat_array;
      this.toastService.hideLoader()
   },(error:any)=>{
    this.toastService.hideLoader()
    this.toastService.create('Having some issues from serve end ')
   })
  }
  get_cat_id(item){
    console.log(item)
    let category_id=item.category_id
    let navigationExtras: NavigationExtras = {
      queryParams: {
        category_id: JSON.stringify(category_id),
      }
    };
    this.router.navigate(['/productlist'], navigationExtras); 
  }

  go_sub_cat(item){
    console.log(item)
    let navigationExtras: NavigationExtras = {
     queryParams: {
       sub_cat: JSON.stringify(item),
     }
   };
   this.router.navigate(['/subcat'], navigationExtras);
   }
}
